import PayPal from './PayPal';
import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import get from 'lodash/get';

import linkFactory from '../../../../analytics/factory/link';
import withCountry from '../../../hocs/withCountry';

const enhance = compose(
  withCountry,
  mapProps(({ paymentMethods, href, country, ...props }) => {
    const paypal = paymentMethods.find(method => method.id === 'paypal_checkout');
    const url = href || get(paypal, 'url', '');
    return {
      ...props,
      url,
      onClick: linkFactory({
        href: url,
        category: 'Cart',
        action: 'Pay With PayPal Checkout',
        label: 'PayPal Checkout',
      })
    };
  }),
);

export default enhance(PayPal);



// WEBPACK FOOTER //
// ./src/client/js/view/components/Checkout/PayPal/index.js